import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { catchError, filter, map, Observable, take, timeout } from 'rxjs';
import { NavigateToForbidden } from 'src/app/states/navigations.actions';
import { CurrentLocationSettingsState } from 'src/states';

export const supplyOrderGuard = (): Observable<boolean> => {
  const store = inject(Store);
  return store.select(CurrentLocationSettingsState.loaded).pipe(
    filter(value => value),
    timeout(30000),
    take(1),
    map(() => {
      const isSupplyOrderingEnabled = store.selectSnapshot(CurrentLocationSettingsState.isSupplyOrderingEnabled);
      if (isSupplyOrderingEnabled) {
        return true;
      }
      store.dispatch(new NavigateToForbidden());
      return false;
    }),
    catchError(() => {
      return store.dispatch(new NavigateToForbidden()).pipe(map(() => false));
    })
  );
};
